import { Box, Button } from "@mui/material";
import { Text } from "@src/appV2/redesign/components/Text";
import { type ReactElement, useCallback, useState } from "react";

import { AnimatedBackgroundPageWrapper } from "../layouts/AnimatedBackgroundPageWrapper";
import { MobileLoginForm } from "./MobileLoginForm";
import { sendLoginEmail } from "./sendLoginEmail";

export function MobileLogin(): ReactElement {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [emailSent, setEmailSent] = useState(false);

  const handleSubmit = useCallback(async () => {
    if (!email) {
      return;
    }

    setLoading(true);

    const success = await sendLoginEmail({
      email,
      requestedURL: localStorage.getItem("redirectURL") ?? undefined,
    });

    if (success) {
      setEmailSent(true);
    }

    setLoading(false);
  }, [email]);

  return (
    <AnimatedBackgroundPageWrapper>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          flex: 1,
          padding: 3,
          paddingTop: "max(24px, env(safe-area-inset-top))",
          paddingBottom: "max(24px, env(safe-area-inset-bottom))",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {/* Logo */}
        <Box
          sx={{
            marginBottom: 4,
            display: "flex",
            justifyContent: "center",
          }}
        >
          <img
            src={`${process.env.REACT_APP_BASE_PATH ?? "/"}brownAndRedBunny.png`}
            alt="Clipboard"
            style={{ height: 150, width: "auto" }}
          />
        </Box>

        {/* Content */}
        <Box
          sx={{
            width: "100%",
            maxWidth: 400,
          }}
        >
          {!emailSent && (
            <MobileLoginForm
              email={email}
              loading={loading}
              setEmail={setEmail}
              onSubmit={handleSubmit}
            />
          )}

          {emailSent && (
            <Box sx={{ textAlign: "center", padding: 2 }}>
              <Text bold variant="h5" sx={{ color: "success.main", marginBottom: 2 }}>
                ✓ Verification Link Sent
              </Text>
              <Text variant="body1" sx={{ color: "text.secondary" }}>
                We have sent an email with a login link to <strong>{email}</strong>.
              </Text>
              <Button
                variant="text"
                sx={{ marginTop: 3, textTransform: "none" }}
                onClick={() => {
                  setEmailSent(false);
                }}
              >
                Send another email
              </Button>
            </Box>
          )}
        </Box>
      </Box>
    </AnimatedBackgroundPageWrapper>
  );
}
